// src/types/mall.ts

export type Mall = "rakuten" | "amazon" | "yahoo";
export type MallOrAll = Mall | "all";

/** モール非依存の店舗参照 */
export type ShopRef = {
    /** 内部一意キー: "rakuten:myshop.rakuten.co.jp" | "amazon:A1B2C3D4" | "yahoo:etre" */
    shopId: string;
    mall: Mall;
    /** モール側の実際のID: shopUrl (楽天) / sellerId (Amazon) / storeId (Yahoo) */
    mallShopId: string;
    displayName?: string;
};

export function buildShopId(mall: Mall, mallShopId: string): string {
    return `${mall}:${mallShopId}`;
}

export function parseShopId(shopId: string): { mall: Mall; mallShopId: string } | null {
    const idx = shopId.indexOf(":");
    if (idx < 0) return null;
    const mall = shopId.slice(0, idx) as Mall;
    const mallShopId = shopId.slice(idx + 1);
    if (!mallShopId) return null;
    return { mall, mallShopId };
}

export function shopRefFromShopUrl(shopUrl: string): ShopRef {
    return {
        shopId: buildShopId("rakuten", shopUrl),
        mall: "rakuten",
        mallShopId: shopUrl,
        displayName: shopUrl,
    };
}

export function shopRefFromSellerId(sellerId: string, displayName?: string): ShopRef {
    return {
        shopId: buildShopId("amazon", sellerId),
        mall: "amazon",
        mallShopId: sellerId,
        displayName: displayName ?? sellerId,
    };
}

export function shopRefFromStoreId(storeId: string, displayName?: string): ShopRef {
    return {
        shopId: buildShopId("yahoo", storeId),
        mall: "yahoo",
        mallShopId: storeId,
        displayName: displayName ?? storeId,
    };
}

export const MALL_LABELS: Record<Mall, string> = {
    rakuten: "楽天",
    amazon: "Amazon",
    yahoo: "Yahoo!",
};
